import React from "react";
import "./HowSupportWorksSection.css";

const HowSupportWorksSection = () => {
  return (
    <section className="_hSWSec_v1A_">
      <div className="_sCont_w2B_">
        <h2 className="_hTitle_s5E_ workflow-title" style={{marginBottom:"1rem", paddingBottom:"1.5rem"}}>How Support Works</h2>
        <ol className="_sList_y4D_">
          <li className="_sItem_z5E_">
            <strong>Contact Us:</strong> Via app, WhatsApp, web portal or email
            with your order or issue details.
          </li>
          <li className="_sItem_z5E_">
            <strong>Acknowledgment:</strong> Auto-confirmation within
            <strong>&nbsp;10 minutes</strong>, personal reply in
            <strong>&nbsp;2 hours</strong>.
          </li>
          <li className="_sItem_z5E_">
            <strong>Investigation:</strong> Our team reviews your ticket, may
            request more details, and works with sellers/community as needed.
          </li>
          <li className="_sItem_z5E_">
            <strong>Resolution:</strong> Most issues close in
            <strong>&nbsp;2 business days</strong>
            (faster for urgent cases: refund, fraud, safety).
          </li>
          <li className="_sItem_z5E_">
            <strong>Escalation:</strong> Not happy or urgent? Escalate to a
            manager. Unresolved? Compliance/legal review.
          </li>
        </ol>
      </div>
    </section>
  );
};

export default HowSupportWorksSection;
